import { useForm } from 'react-final-form';
import type { ISection } from 'store/sets/types';
import { SetSection } from './SetSection';

export const Sections = () => {
  const form = useForm();
  const sections: ISection[] = form.getState().values?.sections ?? [];

  if (!sections.length) return null;

  return (
    <div className="sections-preview">
      {sections.map((section, index) => (
        <SetSection key={section.id ?? index} section={section} />
      ))}
    </div>
  );
};
